import { makeFullMetalUiTheme } from '@facile-it/full-metal-ui/themes/makeFullMetalUiTheme'
import { saturnoVanillaTheme } from './saturno.css'
import { tokens } from './tokens'

export const saturnoTheme = makeFullMetalUiTheme(tokens, saturnoVanillaTheme)
